<script>
  import {opinionModalCurrentArticle, opinionModalToggled} from "../../stores/OpinionModalData";

  import {marked} from "marked";

  export let articleID;
  export let image;
  export let name;
  export let opinion;

  let currentArticle;
  let modalToggled;

  opinionModalCurrentArticle.subscribe(data => currentArticle = data);
  opinionModalToggled.subscribe(data => modalToggled = data);

  function showOpinion(e) {
    opinionModalToggled.set(true);
    opinionModalCurrentArticle.set(articleID);
  }
</script>

<div class="row opinion-container">
    <div class="person-details">
        <img src={image} alt="fotografia"/>
        <h3>{name}</h3>
    </div>
    <p data-aos="fade-up" data-aos-offset="100" class="person-opinion">
        {@html marked(opinion[0])}
        {#if opinion.length > 1}
            <span class="unwrap-opinion" on:click={showOpinion}>CZYTAJ DALEJ</span>
        {/if}
    </p>
</div>

<style>
    .opinion-container {
        box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        padding: 1.565rem 1.875rem;
        position: relative;
        min-height: 320px;
        max-width: 80vw;
        margin-top: 3.75rem;
    }

    .person-details {
        display: flex;
        align-items: center;
    }

    .person-details img {
        width: 60px;
        height: 60px;
        border-radius: 100%;
        padding: 2px;
        border: 2px solid #FDCD18;
    }

    .person-details h3 {
        margin: 0;
        margin-left: .75rem;
        font-size: 1.5rem;
    }

    .person-opinion {
        margin-top: 1.25rem;
        line-height: 1.125rem;
        color: #425466;
        font-family: "Work Sans";
    }

    .person-opinion .unwrap-opinion {
        font-weight: bold;
        cursor: pointer;
    }

    @media (max-width: 768px) {
        .opinion-container {
            width: 85vw;
            padding: 1rem;
            height: auto;
        }
    }
</style>
